import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIframeHeight } from './DynamicIframeUtils';

export class DynamicIframe extends Component {
    static propTypes = {
        htmlString: PropTypes.string,
        style: PropTypes.object,
        onLoad: PropTypes.func,
        onHtmlStringWrite: PropTypes.func,
        autoHeight: PropTypes.bool,
        extraHeight: PropTypes.number,
        longScrollBreakpointWidth: PropTypes.number
    };
    static defaultProps = {
        style: {},
        autoHeight: false,
        extraHeight: 0,
        longScrollBreakpointWidth: Infinity
    };
    constructor(props) {
        super(props);
        this.state = {
            iframeHeight: 'auto'
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.setupIframeHtml();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.htmlString !== this.props.htmlString) {
            this.setupIframeHtml();
        }
    }
    handleIframeLoad = (...args) => {
        const { onLoad } = this.props;
        this.handleResize();
        if (typeof onLoad === 'function') {
            onLoad(...args);
        }
    }
    handleResize = () => {
        const { autoHeight, extraHeight, longScrollBreakpointWidth } = this.props;
        if (this.iframe && autoHeight) {
            const iframeHeight = getIframeHeight(
                window,
                this.iframe,
                extraHeight,
                longScrollBreakpointWidth
            );
            this.setState({
                iframeHeight
            });
        }
    }
    storeIframeRef = (iframeRef) => {
        this.iframe = iframeRef;
    }
    setupIframeHtml = () => {
        const { htmlString, onHtmlStringWrite } = this.props;
        if (typeof htmlString === 'string' && this.iframe && this.iframe.contentWindow) {
            this.iframe.contentWindow.document.open();
            this.iframe.contentWindow.document.write(htmlString);
            this.iframe.contentWindow.document.close();
            this.handleResize();
            if (typeof onHtmlStringWrite === 'function') {
                onHtmlStringWrite();
            }
        }
    }
    render() {
        const {
            htmlString, style, onLoad,
            autoHeight, extraHeight,
            longScrollBreakpointWidth, onHtmlStringWrite,
            ...iframeProps
        } = this.props;
        const { iframeHeight } = this.state;
        const iframeStyle = { height: iframeHeight, ...style };
        return (
            <iframe
                ref={this.storeIframeRef}
                style={iframeStyle}
                onLoad={this.handleIframeLoad}
                {...iframeProps}
            />
        );
    }
}

export default DynamicIframe;
